import { Tab } from '@features/ui';
import { useMemo, useState } from 'react';
import { TTab } from '@src/types';
import {
  ActivePayoutRequests,
  PayoutReporting,
} from '@features/admin/payoutRequests';

export const PayoutRequestsAdmin = () => {
  const [tabActive, setTabActive] = useState(0);
  const tabs: TTab[] = useMemo(
    () => [
      {
        label: 'Active Payout Requests',
        component: <ActivePayoutRequests />,
      },
      {
        label: 'Payout Reporting',
        component: <PayoutReporting />,
      },
    ],
    []
  );

  return (
    <div className={'min-w-[900px]'}>
      <h1 className={'text-[23px]'}>Payout Requests</h1>
      <Tab
        className={'mb-6 mt-4.5'}
        tabActive={tabActive}
        tabs={tabs}
        onChangeTab={setTabActive}
      />
    </div>
  );
};
